module.exports = require("@carvana/icons/Checkmark");